import * as React from 'react';
import { ISingleSelectClosedPropsDerivedFromItemsList, makeSingleSelectInPopover } from './make-single-select-in-popover';

interface ISingleSelectInputProps extends ISingleSelectClosedPropsDerivedFromItemsList {
    className?: string;
}

/**
 * Render regular text input with content, selectable through the SingleSelectList rendered in popover
 */
const SingleSelectInput = makeSingleSelectInPopover(React.forwardRef((props: ISingleSelectInputProps, ref: React.Ref<HTMLInputElement>) => {
    return <input type='text' value={props.name || ''} className={props.className} readOnly={true} ref={ref} />;
}));

export { makeSingleSelectInPopover, SingleSelectInput };
